// Lightweight structured logger for the translation feature.
// Disabled by default in production; toggle via the `enableDebug()` helper or
// by setting `window.__TRANSLATION_DEBUG = true` from the browser console.
const SCOPE = 'translation';
const SAFE_KEYS = new Set([
  'event',
  'inboundOn',
  'outboundPreviewOn',
  'outboundAutoTranslate',
  'peerLang',
  'conversationId',
  'messageIds',
  'count',
  'tokens',
  'status',
  'durationMs',
  'direction',
  'sourceLang',
  'targetLang',
]);

const isEnabled = () => {
  if (typeof window === 'undefined') return false;
  if (window.__TRANSLATION_DEBUG === true) return true;
  const flag = window.localStorage?.getItem('translation_debug');
  return flag === '1' || flag === 'true';
};

const stripSensitive = payload => {
  if (!payload || typeof payload !== 'object') return payload;
  const cleaned = {};
  Object.keys(payload).forEach(key => {
    if (SAFE_KEYS.has(key)) {
      cleaned[key] = payload[key];
    } else if (typeof payload[key] === 'string') {
      cleaned[key] = `len:${payload[key].length}`;
    } else {
      cleaned[key] = payload[key];
    }
  });
  return cleaned;
};

export const logger = {
  enableDebug() {
    if (typeof window !== 'undefined') {
      window.__TRANSLATION_DEBUG = true;
      window.localStorage?.setItem('translation_debug', '1');
    }
  },
  disableDebug() {
    if (typeof window !== 'undefined') {
      window.__TRANSLATION_DEBUG = false;
      window.localStorage?.removeItem('translation_debug');
    }
  },
  isEnabled,
  info(event, payload = {}) {
    if (!isEnabled()) return;
    // eslint-disable-next-line no-console
    console.log(
      `[${SCOPE}] ${event}`,
      JSON.stringify({ ts: Date.now(), ...stripSensitive(payload) })
    );
  },
  warn(event, payload = {}) {
    if (!isEnabled()) return;
    // eslint-disable-next-line no-console
    console.warn(
      `[${SCOPE}] ${event}`,
      JSON.stringify({ ts: Date.now(), ...stripSensitive(payload) })
    );
  },
  error(event, payload = {}) {
    // Errors are always surfaced (regardless of debug flag) but still sanitized.
    // eslint-disable-next-line no-console
    console.error(
      `[${SCOPE}] ${event}`,
      JSON.stringify({ ts: Date.now(), ...stripSensitive(payload) })
    );
  },
};

export default logger;
